import { Box } from '@mui/material';
import classNames from 'classnames';
import { getAgeInYearsOrMonths, removeChar } from '../../../../helper';
import DetailsContainer from '../../../order-management/order-view/OrderTabs/TravellerInfo/DetailsContainer';

interface IHotelJourney {
  data: any;
}

export const HotelJourney = (props: IHotelJourney) => {
  const { data } = props;
  let traveller = data?.contactDetails?.id ? data?.contactDetails : data?.travellers?.[0]
 
  return (
    <div className={classNames('order-view--traveller-card card', 'order-view--tabs')}>
    <div id={`traveller_${removeChar(traveller?.id)}_info`} className='card-body pb-6'>
      <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
        <div className='flex-grow-1'>
          <div className='d-flex justify-content-between align-items-start'>
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center mb-2'>
                <div className='symbol symbol-circle symbol-20px overflow-hidden me-2'>
                  <div className='symbol-label fs-7 bg-info text-light'>
                    {traveller?.firstName?.charAt(0)}
                  </div>
                </div>
                <span className='d-flex flex-column text-capitalize fw-bolder fs-5'>
                  {`${traveller?.firstName} ${traveller?.lastName}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='card-body pt-0 pb-2 border-grey-200'>
      <DetailsContainer 
        data={traveller}
        ancillaryType={"hotel"}
        ancillaryData={traveller}
      />
    </div>
  </div>
  );
};
